import { render, staticRenderFns } from "./ModalPIN.vue?vue&type=template&id=5459a34d&"
import script from "./ModalPIN.vue?vue&type=script&lang=js&"
export * from "./ModalPIN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports